import { EventEmitter } from 'events';
import dispatcher from 'dispatcher';
//import * as Strings from '../../utils/strings';
import * as ActionConstants from 'utils/ActionConstants';
import sessionManager from 'utils/managers/sessionManager';
import axios from 'axios';

class AppStore extends EventEmitter {
    constructor(args) {
        super(args);

        this.loadingState = false;
        this.createdQuote = null;
        this.dispatchToken;
    }
    getAppState = () => {
        return sessionManager.getAppState();
    };
    getLoadingState = () => {
        return this.loadingState;
    };
    getAuth = () => {
        return this.getAppState().auth;
    };
    getUser = () => {
        return this.getAppState().auth.user;
    };
    getCreatedQuote() {
        return sessionManager.getAppState().quote;
    }
    getQuote() {
        return sessionManager.getAppState().quote;
    }
    unsetQuote() {
        sessionManager.setState('quote', {});
    }
    getProfile() {
        return sessionManager.getAppState().profile;
    }

    handleActions = action => {
        if (/_REQUESTED$/.test(action.type)) {
            this.loadingState = action.type.match(/(.+)_REQUESTED$/);
            this.emit('loading_change');
        }
        if (/_SUCCESSFUL$/.test(action.type) || /_FAILURE$/.test(action.type)) {
            this.loadingState = false;
            this.emit('loading_change');
        }
        console.log('ACTION:', action.payload);
        if (/_FAILURE$/.test(action.type) && action.payload.response) {
            if (action.payload.response.data.errors[0].code === 10040) {
                sessionManager.unsetSession();
                this.emit('change');
            }
            if (action.payload.response.data.errors[0].code === 10001) {
                alert(
                    'This email is already in use. Please sign in as an existing user'
                );
            }
        }

        console.log('YOU NEED TO REDE THISE', action);
        switch (action.type) {
            case ActionConstants.LOGIN_SUCCESS: {
                sessionManager.setState('auth', action.payload);
                axios.defaults.headers.common['Authorization'] =
                    'Bearer ' + sessionManager.getAccessToken();

                this.emit('change');
                break;
            }
            case ActionConstants.SIGN_UP_SUCCESS: {
                sessionManager.setState('auth', action.payload);
                axios.defaults.headers.common['Authorization'] =
                    'Bearer ' + sessionManager.getAccessToken();
                this.emit('change');
                break;
            }
            case ActionConstants.EMAIL_VERIFICATION + '_SUCCESSFUL': {
                sessionManager.setState('auth', action.payload.data.auth);
                this.emit('change');
                break;
            }
            case ActionConstants.CREATE_QUOTE + '_SUCCESSFUL': {
                this.createdQuote = action.payload.data;
                sessionManager.setState('quote', action.payload.data);
                this.emit('quote_created');
                break;
            }
            case ActionConstants.GET_QUOTE + '_SUCCESSFUL': {
                sessionManager.setState('quote', action.payload.data);
                this.emit('quote_loaded');
                break;
            }
            case ActionConstants.SHARE_QUOTE + '_SUCCESSFUL': {
                //sessionManager.setState('quote', action.payload.data);
                this.emit('quote_shared');
                break;
            }

            case ActionConstants.CREATE_PROFILE + '_SUCCESSFUL': {
                sessionManager.setState('profile', action.payload.data);
                this.emit('profile_created');
                break;
            }
            case ActionConstants.GET_PROFILE + '_SUCCESSFUL': {
                sessionManager.setState('profile', action.payload.data);
                this.emit('profile_retrieved');
                break;
            }
            case ActionConstants.GET_PORTFOLIO + '_SUCCESSFUL': {
                sessionManager.setState('portfolio', action.payload.data);
                this.emit('portfolio_retrieved');
                break;
            }
            case ActionConstants.GET_LEASE + '_SUCCESSFUL': {
                sessionManager.setState('lease', action.payload.data);
                this.emit('lease_retrieved');
                break;
            }
            case ActionConstants.GET_CREDIT_APP + '_SUCCESSFUL': {
                sessionManager.setState('creditApp', action.payload.data);
                this.emit('credit_app_retrieved');
                break;
            }

            case 'LOGGED_OUT': {
                this.session = null;

                sessionManager.unsetSession();
                this.emit('change');
                break;
            }

            // case ActionConstants.RESET_PASSWORD:

            // case "FAILED_TO_LOGIN":{
            //     //this.emit("change");
            //     //this.session = {errorMsg: Strings.LOGIN_FAILED_ERROR};
            //     break;

            // }
        }
    };
}

const appStore = new AppStore();

appStore.dispatchToken = dispatcher.register(appStore.handleActions);

console.log('DISPATCH TOKEN', appStore.dispatchToken);
appStore.getDispatchToken = () => {
    return this.dispatchToken;
};

export default appStore;



// WEBPACK FOOTER //
// ./src/AppStore.js